import type { RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { driversLoader } from './drivers-loader';

export const driversRoutes: RouteObject = {
  loader: driversLoader,
  children: [
    {
      path: '/admin/drivers',
      lazy: lazyComponent(
        () => import('@pages/tenant/drivers/drivers-list-page'),
        'DriversListPage',
      ),
    },
  ],
};
